import { useCallback } from "react";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";
import { useLoadingSpinnerStore } from "src/store/util/loadingSpinnerUtil";
import { ShowSuccessFetch, showWarning } from "src/utils/toast/toastUtil";
import { getEQM1011_R01List } from "./Api_EQM1011_R01";
import { useEQM1011_R01Store } from "./Store_EQM1011_R01";

interface EQM1011_R01ContentProps {
    setMessage: (message: string) => void;
}

export const Content_EQM1011_R01 = ({ setMessage }: EQM1011_R01ContentProps) => {
    const {
        EQM1011_R01Filter,
        setEQM1011_R01List,
        setScrollTop,
        initData,
    } = useEQM1011_R01Store();
    const { setLoadingSpinner } = useLoadingSpinnerStore();

    useFetchActionbarAuth("EQM1011_R01");

    const fetchData = useCallback(async () => {
        setLoadingSpinner(true);

        try {
            setScrollTop(null);
            const listResponse = await getEQM1011_R01List(EQM1011_R01Filter);
            const fetchedList = listResponse.data.data;
            setEQM1011_R01List(fetchedList);

            if (fetchedList.length === 0) {
                showWarning('조회된 데이터가 없습니다.');
                return;
            }

            ShowSuccessFetch(
                setMessage,
                `조회가 완료되었습니다. (총 ${fetchedList.length}건)`,
            );
        } catch (error) {
            console.error('EQM1011_R01 데이터 조회 실패:', error);
            showWarning('데이터 조회에 실패했습니다.');
        } finally {
            setLoadingSpinner(false);
        }
    }, [
        EQM1011_R01Filter,
        setEQM1011_R01List,
        setLoadingSpinner,
        setMessage,
        setScrollTop,
    ]);

    const handleInitClick = useCallback(() => {
        initData();
        setMessage('데이터가 초기화되었습니다.');
    }, [initData, setMessage]);

    return { fetchData, handleInitClick };
};
